import { FullPageCenter } from "./FullPageCenter";
import Progress from "./Progress";

export { PageLoading };
type Props = {
  label?: string;
  count?: number;
  target?: number;
  indeterminateWhenZero: boolean;
};

const PageLoading = (props: Props) => {
  return (
    // TODO: add CSS for fullPageCenter that lets child components position themselves using classes
    <FullPageCenter>
      <div
        style={{
          placeSelf: "center",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
          }}
        >
          {props.label ?? "Loading"}
        </h2>
      </div>
      <div
        style={{
          placeSelf: "center",
          textAlign: "center",
        }}
      >
        <Progress
          indeterminateWhenZero={props.indeterminateWhenZero}
          count={props.count ?? 0}
          target={props.target ?? 0}
        />
      </div>
    </FullPageCenter>
  );
};
